import { FC } from "react";
import { useTranslation } from "react-i18next";

const HeroSection: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="relative bg-white flex justify-center items-center py-[132px] dmax2:pb-[58px] dmax2:pt-[32px] mx-auto dmin2:w-[1280px] di8:w-[1138px] di7:w-[960px] ti3:w-[860px] td8:w-[767px] ti7:w-[600px] ti8:w-[500px] mi2:w-[440px] mi1:w-[360px] mi5:w-[320px]">
            <div className="flex flex-col justify-between w-full">
                <div className="flex flex-col tmax2:mb-10 dmin2:max-w-[561px] di8:max-w-[561px] di7:max-w-[420px] ti3:max-w-[420px]">
                    <p className="H24B dmax2:H20B text-black uppercase mb-3">{t("heroSection.einfach")}</p>
                    <p className="H24B dmax2:H20B text-black uppercase !leading-[33.6px] dmax2:!leading-7">
                        {t("heroSection.title")}
                    </p>
                    {/* <p className="uppercase font-inter font-[500] text-[19px] dmax2:text-[14px] leading-[22px] text-black my-5 dmax2:my-3">
                        {t("heroSection.text1")}
                    </p>
                    <p className="font-inter font-[700] text-[22px] dmax2:text-[18px] text-black uppercase !leading-[30.8px] mb-4 dmax2:mb-2">
                        {t("heroSection.text2")}
                    </p>
                    <p className="font-inter font-[400] text-[18px] dmax2:text-[15px] text-[#848484] leading-[21.78px] dmax2:leading-[18.15px] mb-4">
                        {t("heroSection.text3")}
                    </p>
                    <p className="H20B dmax2:H16B text-black uppercase mb-2 dmax2:mb-1">{t("heroSection.text4")}</p>
                    <p className="H16 dmax2:H14 text-black mb-1.5 dmax2:mb-[3px]">{t("heroSection.event1")}</p>
                    <p className="H16 dmax2:H14 text-black mb-1.5 dmax2:mb-[3px]">{t("heroSection.event2")}</p>
                    <p className="H16 dmax2:H14 text-black">{t("heroSection.event3")}</p> */}
                </div>
                <div className="flex tmax2:flex-col justify-between items-center tmax2:gap-5">
                    <div className="dmin2:min-w-[655px] dmin2:max-w-[655px] di8:min-w-[600px] di8:max-w-[600px] di7:min-w-[500px] di7:max-w-[500px] ti3:min-w-[400px] ti3:max-w-[400px] td8:min-w-[767px] td8:max-w-[767px]">
                        <img className="w-full" src="images/main-image.png" alt="main" />
                    </div>
                    <a
                        href="https://www.instagram.com/keramikmarkt_utzenstorf/"
                        target="_blank"
                        rel="noreferrer"
                        className="dmin2:min-w-[325px] dmin2:max-w-[325px] di8:min-w-[300px] di8:max-w-[300px] di7:min-w-[275px] di7:max-w-[275px] ti3:min-w-[225px] ti3:max-w-[225px] td8:min-w-[600px] td8:max-w-[600px]"
                    >
                        <img className="w-full" src="images/ads_card.jpg" alt="ads_card" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
